import Debug from '@/util/debug';
// eslint-disable-next-line import/no-webpack-loader-syntax
import rawCss from '!!raw-loader!sass-loader?outputStyle=compact!./style.scss';

const debug = Debug('dynamic-style');

const compileStyle = (style, variables, logo) => {
  let css = style
  .replace(
    /([^\w\d-])--([^,\s)]*)/g,
    (_, prevChar, name) => `${prevChar}${(Object.prototype.hasOwnProperty.call(variables, name) ? variables[name] : '')}`,
  )
  .replace(
    /resolve\((.*?)\)/g, // TODO - allow this to handle rgba() (the parentheses are a problem)
    (_, group) => group.split(',').reduce((acc, val) => acc || val.trim() || null, null),
  );
  if (logo) { // TODO - maybe find better way to change logo
    css += `\n#app .header-logo { background-image: url(${logo}) }`;
  }

  return css;
};

export default {
  props: [
    'variables',
    'logo',
  ],
  data() {
    return {
      styleNode: null,
      iteration: 0,
    };
  },
  computed: {
    css() {
      return compileStyle(rawCss, this.variables, this.logo);
    },
    raw() {
      return rawCss;
    },
  },
  methods: {
    updateStyle() {
      const newNode = document.createElement('style');
      newNode.type = 'text/css';
      newNode.id = `injected-client-style-${this.iteration}`;
      this.iteration += 1;

      if (newNode.styleSheet) {
        newNode.styleSheet.cssText = this.css;
      } else {
        newNode.appendChild(document.createTextNode(this.css));
      }

      this.replaceStyleNode(newNode);
      this.updateThemeColor();
    },
    replaceStyleNode(newNode = null) {
      debug.info(
        'replacing %s with %s',
        (this.styleNode && this.styleNode.id) || null,
        (newNode && newNode.id) || null,
      );

      if (newNode) {
        document.querySelector('head').appendChild(newNode);
      }

      if (this.styleNode) {
        this.styleNode.parentNode.removeChild(this.styleNode);
      }

      this.styleNode = newNode;
      this.$emit('updated');
    },
    updateThemeColor() {
      let element = document.querySelector('head meta[name=theme-color]');
      const newColor = this.variables['color-primary'] || null;

      if (!element && newColor) {
        element = document.createElement('meta');
        element.name = 'theme-color';
        document.querySelector('head').appendChild(element);
      }

      if (newColor) {
        element.content = newColor;
      }

      if (!newColor && element) {
        element.parentNode.removeChild(element);
      }
    },
  },
  watch: {
    css(after, before) {
      if (after !== before) {
        this.updateStyle();
      }
    },
  },
  beforeDestroy() {
    this.replaceStyleNode(null);
  },
  mounted() {
    this.updateStyle();
  },
};



// WEBPACK FOOTER //
// ./src/components/initializer/dynamic-style/DynamicStyle.js